export const AwardItems = [
    {
        awardName: 'C.L. Burton Scholarship',
        time: 'September 2020',
        isExpanded: true,
        descriptionItems: [
            {
                title: 'Awarded for excellence in any subject and/or for general proficiency.',
                sublist: [],
            },
            {
                title: 'Monetary Value: $450',
                sublist: [],
            },
        ],
    },
    {
        awardName: 'J.S. McLean Scholarship',
        time: 'September 2019, 2020, 2021',
        isExpanded: true,
        descriptionItems: [
            {
                title: 'Awarded for excellence in any subject and/or for general proficiency.',
                sublist: [],
            },
            {
                title: 'Monetary Value: $5,000',
                sublist: [],
            },
        ],
    },
    {
        awardName: 'UofT Scholars Award',
        time: 'September 2019',
        isExpanded: true,
        descriptionItems: [
            {
                title: 'Awarded to high-achieving, diverse talented individuals with leadership potential alongside with academic success',
                sublist: [],
            },
            {
                title: 'Monetary Value: $7,500',
                sublist: [],
            },
        ],
    },
    {
        awardName: 'Waterloo Cayley Math Contest Distinction Award',
        time: 'February 2017',
        isExpanded: false,
        descriptionItems: [
            {
                title: 'Awarded for ranking top 25% in the Waterloo Cayley Math Contest',
                sublist: [],
            },
        ],
    },
    {
        awardName: '2nd General Proficiency Award',
        time: 'June 2019',
        isExpanded: false,
        descriptionItems: [
            {
                title: 'Awarded for having the 2nd highest GPA (98%) at North Albion Collegiate Institute',
                sublist: [],
            },
        ],
    },
];